/* eslint-disable eqeqeq */
import React, { useState, useContext, useEffect } from "react";

// Global Fucntions
// import { registerCustomer } from "../../../global-functions/authGlobal";

// Materila ui
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import TextField from "@material-ui/core/TextField";
import LockIcon from "@material-ui/icons/Lock";
import EmailIcon from "@material-ui/icons/Email";
import PersonIcon from "@material-ui/icons/Person";
import PhoneIcon from "@material-ui/icons/Phone";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
// import Page from "../Components/Page";
// import { useNavigate} from "react-router"
import { Link, useHistory } from "react-router-dom";
import StateContext from "../StateContext";

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import DispatchContext from "../DispatchContext";

import MenuItem from "@material-ui/core/MenuItem";
import { Select, FormControl, InputLabel, Input } from "@material-ui/core/";
import { CountryCode } from "../Components/CountryCode";
import Axios from "axios";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import kuwaitFlag from "../Assets/images/kuiwat flag.png";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import { handleError } from "../Functions/getAlert";

const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  menu: {
    width: 200,
  },
});
const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  greyColor: {
    color: "#696969",
  },
}));

// gender

const Gender = [
  {
    value: "Gender",
    label: "Male",
  },
  {
    value: "Gender",
    label: "Female",
  },
  {
    value: "Gender",
    label: "Other",
  },
];

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function SignUpDialog({ handleClose, open, handleLoginOpen }) {
  const classes = useStyles();
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  const [loading, setLoading] = useState(false);
  const [countryCodeValues, setCountryCodeValues] = useState([]);
  let history = useHistory();
  const { t } = useTranslation();

  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });

  const handleClickOpenLogin = () => {
    handleClose();
    handleLoginOpen();
  };

  // password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(true);
  };

  const handleMouseDownPassword = () => {
    setShowPassword(false);
  };
  const handleClickShowConfirm = () => {
    setShowConfirm(true);
  };

  const handleMouseDownConfirm = () => {
    setShowConfirm(false);
  };

  // registration fields
  const [RegisterValues, setRegisterValues] = useState({});

  const updateField = (prop) => (event) => {
    setRegisterValues({ ...RegisterValues, [prop]: event.target.value });
  };
  // // console.log("regis", RegisterValues);
  // for geting  multiple country codes
  useEffect(() => {
    const codeValues = async () => {
      var code = await CountryCode();
      setCountryCodeValues(code);
      // // console.log("codes...", code);
    };
    codeValues();
  }, []);

  // select date of birth function

  const handleSubmits = (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      RegisterValues.first_name &&
      RegisterValues.middle_name &&
      RegisterValues.last_name &&
      RegisterValues.email &&
      RegisterValues.password &&
      RegisterValues.gender &&
      RegisterValues.dob &&
      RegisterValues.confirm_password &&
      RegisterValues.number !== ""
    ) {
      let emailValidation = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailValidation.test(RegisterValues.email)) {
        setAlertMessage({
          open: true,
          message: t("form.Email-Format"),
          alertSuccess: false,
        });
        setLoading(false);
        return;
      }
      if (
        RegisterValues.number.length >= 7 &&
        RegisterValues.number.length < 15
      ) {
        if (RegisterValues.password === RegisterValues.confirm_password) {
          Axios.post(`${process.env.REACT_APP_API_URL}customer/register`, {
            first_name: RegisterValues.first_name,
            last_name: RegisterValues.middle_name,
            middle_name: RegisterValues.last_name,
            email: RegisterValues.email,
            password: RegisterValues.password,
            gender: RegisterValues.gender,
            country_code: "965",
            number: RegisterValues.number,
            dob: RegisterValues.dob,
          })
            .then((response) => {
              if (response.status === 200) {
                if (response.data.success === true) {
                  setAlertMessage({
                    open: true,
                    message: response.data.message,
                    alertSuccess: response.data.success,
                  });
                  setLoading(false);
                  setTimeout(() => {
                    handleClose();
                    // history.push(`/`);
                  }, 3000);
                } else {
                  setAlertMessage({
                    open: true,
                    message: response.data.data,
                    alertSuccess: response.data.success,
                  });
                  setLoading(false);
                }
              } else {
                setAlertMessage({
                  open: true,
                  message: t("form.Something-wrong"),
                  alertSuccess: false,
                });
                return;
              }
            })
            .catch((e) => {
              setLoading(false);
              handleError(e, appDispatch);
              return;
            });
        } else {
          setLoading(false);
          setAlertMessage({
            open: true,
            message: t("form.pass-not-found"),
            alertSuccess: false,
          });

          return;
        }
      } else {
        setLoading(false);
        setAlertMessage({
          open: true,
          message: t("form.correct-mobile"),

          alertSuccess: false,
        });
        return;
      }
    } else {
      setAlertMessage({
        open: true,
        message: t("form.plz-fill"),
        alertSuccess: false,
      });
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    if (loading == false) {
      setTimeout(function () {
        setAlertMessage({
          open: false,
        });
      }, 3000);
    }
  }, [loading]);
  return (
    <div>
      {/* <LoginDialog
        open={openLogin}
        handleClickOpen={handleClickOpenLogin}
        handleClose={handleCloseLogin}
      /> */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>

      <Dialog
        aria-labelledby="customized-dialog-title"
        open={appState.signUpPhoneModal} // yahn open ai ga
        fullWidth
        maxWidth="sm"
        id="Login-Modal"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {/* Modal title */}
        </DialogTitle>

        <div
          style={
            appState.langValue === "ar"
              ? { direction: "rtl" }
              : { direction: "ltr" }
          }
        >
          <div className="login-head pb-0 mt-4">
            <h2>{t("form.registeration")}</h2>
          </div>

          <form action="" onSubmit={handleSubmits}>
            <div className="login-fields signupModal mx-2">
              <div className="row mx-2">
                <div className="col-lg-4 col-md-4  col-sm-12 p-1">
                  <TextField
                    value={RegisterValues.first_name}
                    onChange={updateField("first_name")}
                    name="name"
                    type="text"
                    variant="filled"
                    fullWidth
                    id="input-with-icon-textfield"
                    placeholder={t("form.First-Name")}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="mb-3">
                          <PersonIcon className={`${classes.greyColor}`} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="col-lg-4 col-md-4  col-sm-12 p-1">
                  <TextField
                    type="text"
                    variant="filled"
                    name="middle_name"
                    value={RegisterValues.middle_name}
                    onChange={updateField("middle_name")}
                    fullWidth
                    id="input-with-icon-textfield"
                    placeholder={t("form.Middle-Name")}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="mb-3">
                          <PersonIcon className={`${classes.greyColor}`} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="col-lg-4 col-md-4  col-sm-12 p-1">
                  <TextField
                    name="last_name"
                    value={RegisterValues.last_name}
                    onChange={updateField("last_name")}
                    // type="text"
                    variant="filled"
                    fullWidth
                    id="input-with-icon-textfield"
                    placeholder={t("form.Last-Name")}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="mb-3">
                          <PersonIcon className={`${classes.greyColor}`} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>

              <div className="row mx-2">
                <div className="col-12 col-md-6 col-sm-12 p-1">
                  <TextField
                    value={RegisterValues.email}
                    onChange={updateField("email")}
                    name="email"
                    type="email"
                    variant="filled"
                    fullWidth
                    id="input-with-icon-textfield"
                    placeholder={t("form.Email")}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="mb-3">
                          <EmailIcon className={`${classes.greyColor}`} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>

                <div
                  className={`${
                    appState.langValue === "ar" ? "signUpPhoneNumber" : ""
                  } phone_code col-12 col-md-6 col-sm-12 p-1`}
                >
                  <TextField
                    type="number"
                    prefix="+965"
                    inputProps={{
                      maxLength: 8,
                    }}
                    required
                    variant="filled"
                    value={RegisterValues.number}
                    onChange={updateField("number")}
                    // label="Phone No"
                    onInput={(e) => {
                      e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 8);
                    }}
                    name="phone_no"
                    className="w-100"
                    id="phone_no"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="">
                          <div className="d-flex align-items-center">
                            <img
                              src={kuwaitFlag}
                              alt="kuwaitFlag"
                              height="25px"
                            />

                            <p className="ml-1 mt-4 mobileNo">+965</p>
                          </div>
                        </InputAdornment>
                      ),
                    }}

                    // InputProps={{
                    //   startAdornment: (
                    //     <InputAdornment position="start">

                    //       <FormControl
                    //         id="registerPhoneArrowDown"
                    //         className={`d-flex ${classes.formControl}`}
                    //       >
                    //         <Select
                    //           labelId="demo-simple-select-label"
                    //           defaultValue="965"

                    //           id="demo-simple-select"
                    //           value={
                    //             RegisterValues.country_code != ""
                    //               ? RegisterValues.country_code
                    //               : 956
                    //           }
                    //           onChange={updateField("country_code")}
                    //           // variant="filled"
                    //         >
                    //           <MenuItem value="None">
                    //             <em>None</em>
                    //           </MenuItem>
                    //           {countryCodeValues.map((val, ind) => (
                    //             <MenuItem value={val.code}>
                    //               <span> {val.name} </span> &nbsp; {val.code}
                    //             </MenuItem>
                    //           ))}
                    //         </Select>
                    //       </FormControl>
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                </div>
              </div>
              <div className="row mx-2 mb-2">
                <div className="col-12 col-md-6 col-sm-12 p-1 signUpforButtonEyes">
                  <TextField
                    value={RegisterValues.password}
                    onChange={updateField("password")}
                    name="password"
                    type={showPassword != true ? "password" : "text"}
                    variant="filled"
                    fullWidth
                    id="input-with-icon-textfield"
                    placeholder={t("form.password")}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="mb-3">
                          <LockIcon className={`${classes.greyColor}`} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {!showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div className="text-left">
                    <p
                      style={{ fontSize: "9px" }}
                      className="text-muted small m-0 passwordPara"
                    >
                      {t("form.password-validation")}
                    </p>
                  </div>
                </div>
                {/* <div className="mx-4 text-muted">(Password should be 8 characters long and must include Numbers, Symbols, Uppercase and Lowercase Letters)</div> */}
                <div className="col-12 col-md-6 col-sm-12 p-1 signUpforButtonEyes">
                  <TextField
                    value={RegisterValues.confirmPassword}
                    onChange={updateField("confirm_password")}
                    name="confirm-password"
                    type={showConfirm != true ? "password" : "text"}
                    variant="filled"
                    fullWidth
                    id="input-with-icon-textfield"
                    placeholder={t("form.confirm-pass")}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="mb-3">
                          <LockIcon className={`${classes.greyColor}`} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirm}
                            onMouseDown={handleMouseDownConfirm}
                            edge="end"
                          >
                            {!showConfirm ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>

              <div className="row mx-2 mb-2">
                <div
                  className={`${
                    appState.langValue === "ar"
                      ? "profileformRtlgender profileformRtlGender signUpGender"
                      : "signUpGenderEng"
                  } col-12 col-md-6 col-sm-12 p-1  gendersignUp`}
                >
                  <TextField
                    id="select-currency"
                    select
                    variant="filled"
                    className={classes.textField}
                    value={RegisterValues.gender}
                    onChange={updateField("gender")}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="normal"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className="mb-3">
                          <AccessibilityIcon
                            className={`${classes.greyColor}`}
                          />
                        </InputAdornment>
                      ),
                    }}
                  >
                    {Gender.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.label.toLocaleLowerCase()}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>

                <div className="col-12 col-md-6 col-sm-12 p-1  signupdate">
                  {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    
                  <KeyboardDatePicker
                  
                    clearable
                    value={selectedDate}
                    id="dob-field"
                  
                    inputVariant= "filled"
                    placeholder="10/10/2018"
                    // onChange={(date)=>updateField("dob")}
                    onChange={handleDateChange}
                    className="w-100 m-0 d-flex"
                    minDate={new Date()}
                    format="MM/dd/yyyy"
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    />
                  
                  </MuiPickersUtilsProvider> */}

                  <TextField
                    id="dob-field"
                    name="dob"
                    value={RegisterValues.dob}
                    onChange={updateField("dob")}
                    type="date"
                    className="w-100 DoB"
                    // label="Date Of Birth"
                    variant="filled"
                    required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className=""
                        ></InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>

              {/* <div className="row mx-3">
                <TextField
                  id="date"
                  //   label="Birthday"
                  variant="filled"
                  onChange={handleDateChange}
                  type="date"
                  defaultValue="DATE OF BIRTH"
                  className={classes.textField}
                  minDate={new Date()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div> */}

              <div className="row mb-2 mx-2 regBtn pb-2">
                {/* <div className="col-12 px-4"> */}
                <Button
                  variant="contained"
                  className="btn-main"
                  disabled={loading}
                  type="submit"
                >
                  {loading ? (
                    <React.Fragment>
                      {" "}
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />{" "}
                      Redirecting{" "}
                    </React.Fragment>
                  ) : (
                    t("form.register")
                  )}
                </Button>
                {/* {loading && (
                                    <CircularProgress
                                        size={24}
                                        className={classes.buttonProgress}
                                    />
                                )} */}
                {/* </div> */}
              </div>

              <div className="row mx-3 py-1 text d-flex justify-content-center loginOR ">
                <p>
                  <span className="px-4">OR</span>
                </p>
              </div>
              <div className="row mb-2 mx-2 py-2 regBtn">
                <Button
                  variant="contained"
                  className="register-btn text-primary"
                  disabled={loading}
                  type="button"
                  onClick={() => handleClickOpenLogin()}
                >
                  {loading ? (
                    <React.Fragment>
                      {" "}
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />{" "}
                      Redirecting{" "}
                    </React.Fragment>
                  ) : (
                    "Login"
                  )}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    </div>
  );
}

export default withTranslation()(SignUpDialog);
